import { Component, OnInit } from '@angular/core';
import { App } from "ionic-angular";
import { Projects, Logs, Activities, Updates } from 'api/collections';
import { Project, Log, LogType, LogCategories, Update, Activity } from 'api/models';
import { AlertController, NavParams, ModalController, LoadingController, ActionSheetController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as moment from 'moment';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { PictureService } from '../../services/picture';
import { LogView } from '../../pages/log-view/log-view';
import { AugmentedActivity, ActivityService } from '../../services/activityData';
import { NewLogComponent } from '../../pages/new-log/new-log';
import * as permissions from '../../services/permissions';
import { ISDEV, APP_TITLE } from '../../services/config';
import { HttpService } from '../../services/httpService';
import { Http } from '@angular/http';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'log-menu',
  templateUrl: 'log-menu.html'
})
export class LogMenuComponent implements OnInit {
  public isDev = ISDEV;
  logs: Array < Log & { updateId ? : string, update ? : Update } > ;
  project: Project | void; //holds Project info for activity list
  update: Update | void; //holds Project info for activity list
  projects; //need to remove after testing and removal of existing projects functions
  selectedProject: Project | void;
  activityId: string;
  projectId: string;
  updateId: string;
  p6ActivityId: string;
  activity: AugmentedActivity | void;
  logType: LogType;
  newLogTitle: string;
  newLogSelection: string;
  newLogCategory: string;
  logTypeLabel: string;
  initialPhoto: string | void;
  initialTextMessage: string | void;

  logCategoryOptions = [
    { value: LogCategories.CHANGES, label: 'Changes' },
    { value: LogCategories.DELAYS, label: 'Delays/Issues' },
    { value: LogCategories.INSPECTIONS, label: 'Inspections' },
    { value: LogCategories.SAFETY, label: 'Site Safety' },
    { value: LogCategories.NOTES, label: 'Subcontractor Notes' },
    { value: LogCategories.TODO, label: 'To Do List' },
    { value: LogCategories.WEATHER, label: 'Weather' },
  ];

  constructor(
    private _app: App,
    public navParams: NavParams,
    public authenticationService: AuthenticationService,
    private alertCtrl: AlertController,
    private pictureService: PictureService,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl: ModalController,
    private sharedService: SharedService,
    public httpService: HttpService,
    private activityService: ActivityService,
    public projectService: ProjectService
  ) {}
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
    const projectIdReactive = this.navParams.get('projectIdReactive');
    const projectId = projectIdReactive && projectIdReactive.get();
    const activityId = <string> this.navParams.get('activityId');
    this.p6ActivityId = <string> this.navParams.get('p6ActivityId');
    this.logType = activityId ? LogType.ACTIVITY : LogType.GENERAL;
    this.projectId = <string> this.navParams.get('projectId');
    this.updateId = <string> this.navParams.get('updateId');
    this.project = this.projectService.getProject(projectId);

    /*
    MeteorObservable.subscribe('currentUpdateForProject', this.projectId).subscribe(() => {
      if(!this.updateId){
        this.update = Updates.find({
          projectId: this.projectId,
          archived: {$ne:true}
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
      } else {
        this.update = Updates.find({
          _id: this.updateId,
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
      }
    });

    MeteorObservable.subscribe('logs', this.projectId, this.p6ActivityId).subscribe(() => {
      this.populateLogs();
    });
    */

    this.httpService.MeteorSubscribe('currentUpdateForProject', this.projectId)
    .then(()=>this.httpService.privateLoopAction(true))
    if(!this.updateId){
      this.update = Updates.find({
        projectId: this.projectId,
        archived: {$ne:true}
      }, {
        limit: 1,
        sort: { createdAt: -1 },
      }).fetch()[0];
    } else {
      this.update = Updates.find({
        _id: this.updateId,
      }, {
        limit: 1,
        sort: { createdAt: -1 },
      }).fetch()[0];
    }

    this.httpService.MeteorSubscribe('logs', this.projectId, this.p6ActivityId)
    this.populateLogs();

    if (this.logType === LogType.ACTIVITY) {
      this.logTypeLabel = 'Activity Log';
    } else if (this.logType === LogType.GENERAL) {
      this.logTypeLabel = 'General Project Log';
    } else {
      this.logTypeLabel = 'Unknown';
    }

     this.populateLogs();

    // TODO should subscribe to guarantee the activity data is available
    MeteorObservable.autorun().subscribe(() => {
      /*
      MeteorObservable.call("getActivity",
        activityId
      ).subscribe({
        error: (e: Error) => {
        if(this.isDev == true) { console.error(e) }
      },
        next: (res: any) => {
         if(this.isDev == true) {  console.log("finding activity ", activityId, res) }
          this.activity = res ? getAugmentedActivity(res) : null;
        }
      });
      */

      this.httpService.MeteorCall('getActivity', activityId)
        .then((res: any) => {
          if(this.isDev == true) {  console.log("finding activity ", activityId, res) }
          this.activity = res ? this.activityService.getAugmentedActivity(res) : null;
        })
        .catch(err => console.log('meteor call error:', err));

      const activity = Activities.findOne(activityId);
    if(this.isDev == true) {   console.log('looking at activity: ', activity) }


      this.project = this.projectService.getProject(this.projectId);
     if(this.isDev == true) {  console.log("this.project", this.project, this.projectId) }


     if(this.isDev == true) {  console.log("logs", this.logs) }
    });
  }

  showAttachments(): void {
    this.pictureService.getPicture(this.actionSheetCtrl)
      .then((blob: File) => {
        let loading = this.loadingCtrl.create({
          content: 'Uploading image...',
          duration: 10 * 1000,
        });

        loading.present();
        this.pictureService.upload(blob).then((picture) => {
          this.initialPhoto = picture.url;
          loading.dismiss();
        }).catch((e) => {
         if(this.isDev == true) {   console.error(e) }
        });
     }).catch((e) => {
         if(this.isDev == true) {   console.error(e) }
        });
  }

   async populateLogs() {
    this.logs = await this.findLogs();
  }

  async findLogs(): Promise<Array<Log & { updateId?: string, update?: Update }>> {
    if (!this.projectId) {
      return [];
    }

    let logs = Logs.find({
      projectId: this.projectId,
      p6ActivityId: this.p6ActivityId
    }).fetch();

    for(const i in logs){
      logs[i].featuredImage=logs[i].featuredImage?await this.authenticationService.imageConverter(logs[i].featuredImage):logs[i].featuredImage
    }
    const augmentedLogs: Array<Log & {updateId?: string, update?: Update }> = logs.map(log => {

      let update = undefined;
      let updateId = undefined;
      const p6ActivityId = log && log.p6ActivityId;
      if (p6ActivityId) {
        const activity = Activities.find({
          p6ActivityId: log.p6ActivityId,
          projectId: log.projectId,
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
        updateId = (activity || {updateId: undefined}).updateId;
        if (updateId) {
          update = Updates.findOne(updateId);
        }
      }

      return {
        ...log,
        update,
        updateId,
      };
    });

    return augmentedLogs;


  }
  /** END LogListHeaderBar **/

  goToLog(log): void {
    const modal = this.modalCtrl.create(LogView, { logId: log._id }, { enableBackdropDismiss: false });
    modal.present();
  }



  addLog(activity: AugmentedActivity, activityId, projectId, p6ActivityId): void {
   if(this.isDev == true) {
      console.log('activity ' + activityId);
      console.log('project ' + this.project);
      console.log('p6 ' + this.p6ActivityId );
    }
      const modal = this.modalCtrl.create(NewLogComponent, {
        activityId: activity._id,
        projectId: activity.projectId,
        p6ActivityId: activity.p6ActivityId,
        updateId: activity.updateId
      }, { enableBackdropDismiss: true });
      modal.present();

  }

  showError(e: Error): void {
   if(this.isDev == true) {  console.error(e) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/log-menu/log-menu.ts